import { previewFile } from '@/services/firebase-storage-service';
import { isAudioSourceType } from '@/utils/file-upload';

type OpenPreviewOptions = {
  source?: string | null;
};

type OpenSourcePreviewOptions = {
  id: string;
  sourceType?: string | null;
  source?: string | null;
  onOpenPreview?: (previewId: string) => void;
};

export const isMediaSourceType = (sourceType?: string | null) => {
  return !!sourceType && (sourceType.startsWith('image/') || isAudioSourceType(sourceType));
};

export const resolveSourcePreviewUrl = async (source: string): Promise<string> => {
  if (source.startsWith('http://') || source.startsWith('https://')) {
    return source;
  }

  return previewFile(source);
};

export const openSourcePreviewInNewTab = async ({ source }: OpenPreviewOptions): Promise<void> => {
  if (!source) return;

  const previewUrl = await resolveSourcePreviewUrl(source);
  if (!previewUrl) return;

  window.open(previewUrl, '_blank', 'noopener,noreferrer');
};

export const openSourcePreview = async ({ id, sourceType, source, onOpenPreview }: OpenSourcePreviewOptions): Promise<void> => {
  if (isMediaSourceType(sourceType) && source) {
    await openSourcePreviewInNewTab({ source });
    return;
  }

  onOpenPreview?.(id);
};
